import baseReducer from '@utilities/base-reducer'
import produce from 'immer'
import * as Actions from './security-step-action'

const initialState = {
  captcha: '',
  password: '',
  confirmPassword: '',
}

const onboardingReducer = baseReducer(initialState, {
  [Actions.SET_SECURITY_FIELD](state, { payload: { name, value } }) {
    return { ...state, [name]: value }
  },
})

export default onboardingReducer
